module.exports = __webpack_public_path__ + "img/user.2d302f26.svg";